import type { FunctionComponent } from 'react';
import Question from '../../../interfaces/question';
import { formatQuestionTypeToClass } from '../../../utils/formatQuestionTypeToClass';
import QuestionFactory from '../utils/questionFactory';
import * as styles from './Subquestion.module.css';

interface SubQuestionProps {
  question: Question;
}

const SubQuestion: FunctionComponent<SubQuestionProps> = ({ question }) => {
  const questionTypeClass = formatQuestionTypeToClass(question.type);
  const questionLabel = question.value;

  return (
    <div className={`${styles.multipleContainer} ${styles[questionTypeClass]}`}>
      {questionLabel && <p className={styles.questionLabel}>{question.value}</p>}
      <QuestionFactory question={question} />
    </div>
  );
};

export default SubQuestion;
